define(["require", "exports", "tslib", "@material-ui/core/IconButton", "@material-ui/core/ListItemText", "@material-ui/core/Menu", "@material-ui/core/MenuItem", "@material-ui/icons/AccountCircle", "mobx-react", "react", "../model/services", "../store/Events", "../store/StoreManager", "../store/UserStore", "../utils/Environment", "./blocks"], function (require, exports, tslib_1, IconButton_1, ListItemText_1, Menu_1, MenuItem_1, AccountCircle_1, mobx_react_1, React, services_1, Events_1, StoreManager_1, UserStore_1, Environment_1, blocks_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.UserProfile = void 0;
    IconButton_1 = tslib_1.__importDefault(IconButton_1);
    ListItemText_1 = tslib_1.__importDefault(ListItemText_1);
    Menu_1 = tslib_1.__importDefault(Menu_1);
    MenuItem_1 = tslib_1.__importDefault(MenuItem_1);
    AccountCircle_1 = tslib_1.__importDefault(AccountCircle_1);
    React = tslib_1.__importStar(React);
    let UserProfile = exports.UserProfile = class UserProfile extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "handleClick", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    this.setState({
                        anchorEl: e.currentTarget
                    });
                }
            });
            Object.defineProperty(this, "handleClose", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.setState({
                        anchorEl: null
                    });
                }
            });
            Object.defineProperty(this, "logout", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    const { userStore: user } = this.props;
                    user.logOut();
                    services_1.EventManager.Instance.emitAsync(Events_1.ROUTE_ENTER_EVENT, "/");
                }
            });
            this.state = {
                anchorEl: null
            };
        }
        render() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            const { userStore: user } = this.props;
            const { anchorEl } = this.state;
            return (React.createElement("div", null,
                React.createElement(IconButton_1.default, { "aria-label": "add", "aria-owns": anchorEl ? "simple-menu" : null, "aria-haspopup": "true", onClick: this.handleClick, style: {
                        margin: 0,
                    } },
                    React.createElement(blocks_1.VGroup, { style: {
                            alignItems: "center",
                            gap: 10,
                            color: "#d4d7de",
                        } },
                        React.createElement(AccountCircle_1.default, { style: {
                                color: "#d4d7de",
                                width: "32px",
                                height: "32px"
                            } }),
                        React.createElement("div", { style: {
                                fontSize: "0.8rem",
                                fontWeight: 400,
                                letterSpacing: "0.03em"
                            } }, (_b = (_a = user === null || user === void 0 ? void 0 : user.User) === null || _a === void 0 ? void 0 : _a.userData) === null || _b === void 0 ? void 0 : _b.FirstName))),
                React.createElement(Menu_1.default, { id: "simple-menu", anchorEl: anchorEl, open: Boolean(anchorEl), onClose: this.handleClose },
                    React.createElement(MenuItem_1.default, null,
                        React.createElement(blocks_1.VGroup, null,
                            React.createElement(blocks_1.HGroup, null,
                                "Logged in as:\u00A0",
                                React.createElement("strong", null, (_d = (_c = user === null || user === void 0 ? void 0 : user.User) === null || _c === void 0 ? void 0 : _c.userData) === null || _d === void 0 ? void 0 :
                                    _d.FirstName,
                                    " ", (_f = (_e = user === null || user === void 0 ? void 0 : user.User) === null || _e === void 0 ? void 0 : _e.userData) === null || _f === void 0 ? void 0 :
                                    _f.LastName,
                                    " (", (_g = user === null || user === void 0 ? void 0 : user.User) === null || _g === void 0 ? void 0 :
                                    _g.id,
                                    (0, UserStore_1.isUserStateGovAdminOfficer)() ? ", Admin" : "",
                                    ")")),
                            !(0, Environment_1.isProduction)()
                                ? React.createElement(blocks_1.VGroup, null,
                                    React.createElement("strong", null, "Debug info (not visible in production)"), (_j = (_h = user.User) === null || _h === void 0 ? void 0 : _h.roles) === null || _j === void 0 ? void 0 :
                                    _j.map(x => React.createElement("div", null, x)))
                                : null)),
                    React.createElement(MenuItem_1.default, { onClick: this.logout },
                        React.createElement(ListItemText_1.default, null, "Logout")))));
        }
    };
    exports.UserProfile = UserProfile = tslib_1.__decorate([
        (0, mobx_react_1.inject)(context => (0, StoreManager_1.injectStores)(context)),
        mobx_react_1.observer
    ], UserProfile);
});
